import { _ as _slicedToArray } from '../slicedToArray-b4278ecd.js';
import IS_BROWSER from '../isBrowser/index.js';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function normalizeDomain(domain) {
  if (!domain && IS_BROWSER) {
    var parts = window.location.hostname.split('.');
    if (parts.length >= 3) {
      return parts.slice(-2).join('.'); // Return parent domain (domain.com) for a subdomain (xxx.domain.com)
    }
    return parts.join('.');
  }
  var modifiedDomain = domain !== null && domain !== void 0 && domain.startsWith('.') ? domain.substring(1) : domain;
  return modifiedDomain || '';
}

/**
 * Sets cookie
 * @param name cookie name
 * @param value cookie value
 * @param [domain] domain
 * @param [path] path
 * @param [daysToExpire] exiration in days
 * @returns void
 */
function setCookie(name, value, domain) {
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
  var daysToExpire = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 365;
  if (!IS_BROWSER) {
    return;
  }
  var date = new Date();
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000); // Convert days to milliseconds
  document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(date.toUTCString(), ";path=").concat(path, ";domain=").concat(normalizeDomain(domain));
}

/**
 * Deletes cookie
 * @param name cookie name
 * @param [domain] domain
 * @param [paths] path
 * @returns void
 */
function deleteCookie(name, domain) {
  var paths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['/'];
  if (!IS_BROWSER) {
    return;
  }
  var expires = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
  var normalizedDomain = normalizeDomain(domain);
  var domains = [normalizedDomain, ".".concat(normalizedDomain)];
  var _iterator = _createForOfIteratorHelper(paths),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var path = _step.value;
      var _iterator2 = _createForOfIteratorHelper(domains),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var domainValue = _step2.value;
          document.cookie = "".concat(name, "=;").concat(expires, ";path=").concat(path, ";domain=").concat(domainValue, ";");
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

/**
 * Gets cookie
 * @param name cookie name
 * @returns cookie value or null if not found
 */
function getCookie(name) {
  if (!IS_BROWSER) {
    return null;
  }
  var cookieString = document.cookie;
  var cookies = cookieString.split('; ');
  var _iterator3 = _createForOfIteratorHelper(cookies),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var cookie = _step3.value;
      var _cookie$split = cookie.split('='),
        _cookie$split2 = _slicedToArray(_cookie$split, 2),
        cookieName = _cookie$split2[0],
        cookieValue = _cookie$split2[1];
      if (cookieName === name) {
        return cookieValue;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return null;
}
function getSSRCookie(cookies, key) {
  var reg = new RegExp("(?:(?:^|.*;\\s*)".concat(key, "\\s*\\=\\s*([^;]*).*$)|^.*$"));
  if (cookies) {
    var result = cookies.replace(reg, '$1');
    return result === cookies || result === '' ? null : result; // if the regex replacement didn't change anything, return null
  }
  return null;
}

export { deleteCookie, getCookie, getSSRCookie, normalizeDomain, setCookie };
//# sourceMappingURL=index.js.map
